<!--
 * @Descripttion: 
 * @Author: qixiao
 * @Date:2022-5-26 09:46:59
 * @LastEditors: qixiao
 * @LastEditTime: 2022-5-26 09:46:59
-->
<template>
  <div class="apps">
    <div class="hrs"></div>
    <el-main>
      <div class="top-wrap">
        <Bread></Bread>
      </div>
      <div class="main">
        <div class="nav">
          <span class="h1-top">{{ realData.deviceName }}</span>
          <span class="span-top"
            >设备序列号: <span>{{ realData.deviceCode }}</span>
          </span>
        </div>
        <div class="box-top">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button type="primary" class="searchButton" @click="search"
            >查询</el-button
          >
          <el-button @click="reset">清空</el-button>
        </div>
        <div class="box-center">
          <div>
            <div
              class="demo-image__preview"
              v-for="item in siteList"
              :key="item.id"
            >
              <el-image
                style="width: 100%; height: 100px; text-align: center"
                :src="item.imgeUrl"
                :preview-src-list="srcList"
              >
              </el-image>
              <p>{{ timestampToTime_Y(item.createTime) }}</p>
              <p>{{ timestampToTime_H(item.createTime)}}</p>
            </div>
          </div>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="parmy.pageNum"
          :page-size="parmy.pageSize"
          layout="total,prev, pager, next, jumper"
          :total="parmy.total"
        >
        </el-pagination>
      </div>
    </el-main>
  </div>
</template>

<script>
export default {
  name: "AgrMonitoringVigour",
  data() {
    return {
      value1: "",
      url: "",
      srcList: [],
      imgPath: "",
      siteList: [],
      parmy: {
        pageNum: 1,
        pageSize: 28,
        total: 0,
      },
      realData: {
        deviceCode: "-",
        deviceName: "-",
      },
    };
  },
  mounted() {},
  created() {
    this.getListImg();
  },
  methods: {
    getListImg(data) {
      let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
      this.realData = {
        deviceCode: farmAllData.deviceCode,
        deviceName: farmAllData.deviceName,
      };
      let obj = "";
      if (data) {
        obj = data;
      } else {
        obj = {
          deviceCode: this.realData.deviceCode,
          startTime: "",
          endTime: "",
          type: "3",
          currentPage: this.parmy.pageNum,
          pageSize: this.parmy.pageSize,
        }; //1近七天 2近30天 3自定义时间（yyyy-MM-dd）
      }

      this.$http.agrModel.getSiteImage(obj).then((res) => {
        console.log(res);
        if (res.status === "1") {
          console.log(res);
          this.siteList = res.data.content;
          this.parmy.total = res.data.recordTotal;
          this.srcList = [];
          this.siteList.forEach((item, index) => {
            this.srcList.push(item.imgeUrl);
          });
        } else {
          this.$message({
            message: res.errMsg,
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
    search() {
      this.parmy.pageNum = 1;
      let obj;
      if (this.value1) {
        obj = {
          deviceCode: this.realData.deviceCode,
          startTime: this.value1[0],
          endTime: this.value1[1],
          type: "3",
          currentPage: this.parmy.pageNum,
          pageSize: this.parmy.pageSize,
        };
      } else {
        obj = {
          deviceCode: this.realData.deviceCode,
          startTime: "",
          endTime: "",
          type: "3",
          currentPage: this.parmy.pageNum,
          pageSize: this.parmy.pageSize,
        };
      }

      this.getListImg(obj);
    },
    reset() {
      this.value1 = "";
      this.getListImg();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    timestampToTime_Y(timestamp) {
      var date = new Date(timestamp * 1); //这个是10位数字的转换 如果想要13位数的话需要乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
    timestampToTime_H(timestamp) {
      var date = new Date(timestamp * 1); //这个是10位数字的转换 如果想要13位数的话需要乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return h + m + s;
    },
    handleCurrentChange(val) {
      this.parmy.pageNum = val;
      this.getListImg();
    },
  },
};
</script>

<style lang='scss' scoped>
.apps {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto;

  ::v-deep .el-date-editor.el-input__inner {
    width: 30%;
    margin-left: 2vh;
  }

  .searchButton {
    margin-left: 1vh;
  }

  ::v-deep .box-top .el-button {
    width: 100px;
  }
  .demo-image__preview {
    width: 12%;
    display: inline-block;
    margin-left: 2vh;
    margin-bottom: 2vh;

    p {
      text-align: center;
    }
  }
  .box-center {
    padding-top: 2vh;
  }
  .nav {
    height: 3vh;
    margin-bottom: 3vh;
    position: relative;
    .h1-top {
      font-size: 22px;
      color: #333;
      margin-right: 4vh;
      font-weight: 700;
    }
    .span-top {
      font-size: 16px;
      margin-right: 4vh;
      color: #888;
    }
    .span-go {
      position: absolute;
      right: 5vh;
      top: 1vh;
      font-size: 16px;
      text-align: right;
      cursor: pointer;
      color: #018388;

      i {
        font-size: 16px;
        margin-right: 0.5vh;
      }
    }
  }
  .hrs {
    position: absolute;
    top: 120px;
    left: 2vh;
    width: 98%;
    height: 1px;
    background-color: #efefef;
  }
}
</style>
